"use client"

import { Crop } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CropIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CropIcon = component(Icon)({ as: Crop })
